import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, ClockIcon, CarIcon, PlaneIcon, ExternalLinkIcon } from 'lucide-react';
const MAP_URL = 'https://mapy.com/cs/turisticka?planovani-trasy&rc=9hOj9xXGb0&rs=&rs=coor&ri=&ri=&mrp=%7B%22c%22%3A111%2C%22dt%22%3A%22%22%2C%22d%22%3Atrue%7D&xc=%5B%5D&rut=1&x=14.5184141&y=49.9449350&z=17';
export function LocationSection() {
  return <section id="lokalita" className="py-24 bg-white overflow-hidden" data-id="element-151">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-152">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-153">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-154">
            <div className="flex items-center gap-3 text-accent mb-4" data-id="element-155">
              <MapPinIcon className="w-5 h-5" data-id="element-156" />
              <span className="font-medium tracking-wider uppercase text-sm" data-id="element-157">
                Dolní Jirčany, Praha-západ
              </span>
            </div>
            <h2 className="font-heading text-4xl md:text-5xl text-primary mb-6" data-id="element-158">
              Lokalita
            </h2>

            <div className="space-y-6 text-base-gray text-lg mb-10" data-id="element-159">
              <p data-id="element-160">
                Projekt se nachází ve strategické a vyhledávané lokalitě, která
                kombinuje klid venkova s výbornou dostupností do metropole.
              </p>
              <ul className="space-y-4" data-id="element-161">
                <li className="flex items-start gap-3" data-id="element-162">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" data-id="element-163" />
                  <span data-id="element-164">15 min autem do centra Prahy</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-165">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" data-id="element-166" />
                  <span data-id="element-167">Blízkost dálnice D1 pro snadné cestování</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-168">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" data-id="element-169" />
                  <span data-id="element-170">Pravidelné autobusové spojení MHD</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-171">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" data-id="element-172" />
                  <span data-id="element-173">Okolní příroda a lesy ideální pro relaxaci</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-174">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" data-id="element-175" />
                  <span data-id="element-176">Kompletní občanská vybavenost v obci</span>
                </li>
              </ul>
            </div>

            <div className="flex flex-wrap gap-4" data-id="element-177">
              <div className="flex items-center gap-2 bg-base-cream px-4 py-2 rounded-full text-sm font-medium text-primary" data-id="element-178">
                <CarIcon className="w-4 h-4" data-id="element-179" />
                Praha centrum - 15 min
              </div>
              <div className="flex items-center gap-2 bg-base-cream px-4 py-2 rounded-full text-sm font-medium text-primary" data-id="element-180">
                <PlaneIcon className="w-4 h-4" data-id="element-181" />
                Letiště - 25 min
              </div>
              <div className="flex items-center gap-2 bg-base-cream px-4 py-2 rounded-full text-sm font-medium text-primary" data-id="element-182">
                <ClockIcon className="w-4 h-4" data-id="element-183" />
                D1 - 5 min
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative h-[500px] w-full bg-base-cream rounded-2xl border border-primary/10 flex items-center justify-center p-8 overflow-hidden shadow-xl" data-id="element-184">
            {/* Background Image */}
            <img src="https://cdn.magicpatterns.com/uploads/pBPDF5SFGUcvhqAVU9DGHy/18.png" alt="Nádvoří Svatý Václav" className="absolute inset-0 w-full h-full object-cover" data-id="element-185" />

            {/* Overlay to ensure card readability */}
            <div className="absolute inset-0 bg-primary/10" data-id="element-186"></div>

            {/* Stylized Map Placeholder Pattern */}
            <div className="absolute inset-0 opacity-20 mix-blend-multiply" style={{
            backgroundImage: 'radial-gradient(#4A4543 1px, transparent 1px)',
            backgroundSize: '20px 20px'
          }} data-id="element-187"></div>

            <div className="relative z-10 bg-white/95 backdrop-blur-sm p-8 rounded-xl shadow-2xl max-w-sm text-center border-t-4 border-primary" data-id="element-188">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-189">
                <MapPinIcon className="w-8 h-8 text-primary" data-id="element-190" />
              </div>
              <h3 className="font-heading text-2xl font-bold text-base-dark mb-2" data-id="element-191">
                Svatý Václav
              </h3>
              <p className="text-base-gray mb-4" data-id="element-192">
                Dolní Jirčany
                <br data-id="element-193" />
                Praha-západ
              </p>
              <div className="h-px w-full bg-gray-100 my-4" data-id="element-194" />
              <a href={MAP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-accent hover:text-accent-hover font-medium transition-colors" data-id="element-195">
                Zobrazit na mapě
                <ExternalLinkIcon className="w-4 h-4" data-id="element-196" />
              </a>
            </div>

            {/* Decorative elements */}
            <div className="absolute top-10 right-10 w-32 h-32 bg-primary/20 rounded-full blur-2xl" data-id="element-197"></div>
            <div className="absolute bottom-10 left-10 w-40 h-40 bg-accent/20 rounded-full blur-2xl" data-id="element-198"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}